export enum ColorEnum {
  White = '#FFFFFF',

  AdditionalSeaside75 = '#98C3CC',

  DavyGrey = '#4B5359',
  OuterSpace = '#3F474D',

  MonochromesCloud = '#F9FAFB',

  Black3 = '#F9F9F9',
  Black10 = '#EAEBEB',
  Black20 = '#D6D7D8',
  Black30 = '#C1C3C5',
  Black40 = '#ADB0B2',
  Black50 = '#949698',
  Black70 = '#717578',
  Black80 = '#5D6165',
  Black90 = '#484D52',
  Black100 = '#33393E',
  Black150 = '#2C3236',

  IndicationSuccess50 = '#9ECE87',
  IndicationSuccess100 = '#389E0D',
  IndicationSuccess150 = '#3A8F0B',

  Green6 = '#52C41A',
  Green3 = '#B7EB8F',
  Green1 = '#F6FFED',

  Gold6 = '#FAAD14',
  Gold3 = '#FFE58F',
  Gold1 = '#FFFBE6',

  Red6 = '#F5222D',
  Red3 = '#FFA39E',
  Red1 = '#FFF1F0',
  Error100 = '#C80F25',

  Teal30 = '#D2E7EA',
  Teal100 = '#63B1BC',
  Teal150 = '#4599A5',

  Wood100 = '#E7CEB5',

  Inherit = 'inherit',
}
